export enum FUNDING_STATUS {
  CS_TO_DORPGS = 'CS_TO_DORPGS',
  DORPGS_TO_GS = 'DORPGS_TO_GS',
  FAILED_LIST = 'FAILED_LIST',
  SUCCESSFUL_LIST = 'SUCCESSFUL_LIST',
  // ipfs
  SUCCESSFUL_OUTSTANDING_LIST = 'SUCCESSFUL_OUTSTANDING_LIST',
  // polyu competitive
  SUCCESSFUL_EXCEPTIONALLY_GOOD_LIST = 'SUCCESSFUL_EXCEPTIONALLY_GOOD_LIST',
  SUCCESSFUL_VERY_GOOD_LIST = 'SUCCESSFUL_VERY_GOOD_LIST',
  SUCCESSFUL_GOOD_LIST = 'SUCCESSFUL_GOOD_LIST',
  // hkpfs
  GS_TO_RGC = 'GS_TO_RGC',
  RGC_SUCCESSFUL_LIST = 'RGC_SUCCESSFUL_LIST',
  RGC_WAITING_LIST = 'RGC_WAITING_LIST',
  RGC_TOP_UP_LIST = 'RGC_TOP_UP_LIST',
  RGC_FAILED_LIST = 'RGC_FAILED_LIST',
}

export enum FUNDING_STATUS_DISPLAY_STRING {
  APPLICATION = 'Applied by Applicant',
  CS_TO_DORPGS = 'Recommended by CS',
  DORPGS_TO_GS = 'Nominated by DoRPgS',
  SUCCESSFUL_LIST = 'Successful',
  FAILED_LIST = 'Failed',
  // hkpfs
  GS_TO_RGC = 'HKPFS Nominee',
  RGC_SUCCESSFUL_LIST = 'RGC Main',
  RGC_TOP_UP_LIST = 'RGC Top-up',
  RGC_WAITING_LIST = 'RGC Waiting',
  RGC_FAILED_LIST = 'RGC Failed',
  // ipfs
  SUCCESSFUL_OUTSTANDING_LIST = 'Successful Outstanding (IPFS)',
  // polyu competitive
  SUCCESSFUL_EXCEPTIONALLY_GOOD_LIST = '3 yrs from Central (Successful)',
  SUCCESSFUL_VERY_GOOD_LIST = '2 yrs from Central (Successful)',
  SUCCESSFUL_GOOD_LIST = '1 yr from Central (Successful)',
}

export const HKPFS_NOMINEE_FILTER = [
  FUNDING_STATUS.GS_TO_RGC,
  FUNDING_STATUS.RGC_FAILED_LIST,
  FUNDING_STATUS.RGC_TOP_UP_LIST,
  FUNDING_STATUS.RGC_WAITING_LIST,
  FUNDING_STATUS.RGC_SUCCESSFUL_LIST,
];

export const SUCCESSFUL_FUNDING_STATUS = [
  FUNDING_STATUS.SUCCESSFUL_LIST,
  FUNDING_STATUS.GS_TO_RGC,
  FUNDING_STATUS.RGC_SUCCESSFUL_LIST,
  FUNDING_STATUS.RGC_TOP_UP_LIST,
  FUNDING_STATUS.SUCCESSFUL_OUTSTANDING_LIST,
  FUNDING_STATUS.SUCCESSFUL_EXCEPTIONALLY_GOOD_LIST,
  FUNDING_STATUS.SUCCESSFUL_VERY_GOOD_LIST,
  FUNDING_STATUS.SUCCESSFUL_GOOD_LIST,
];

// allow DoRPgS to change chief supervisor
export const DORPGS_CHANGE_SUP_FUNDING_STATUS = [
  FUNDING_STATUS.CS_TO_DORPGS,
  FUNDING_STATUS.DORPGS_TO_GS,
  FUNDING_STATUS.FAILED_LIST,
  FUNDING_STATUS.GS_TO_RGC,
  FUNDING_STATUS.RGC_SUCCESSFUL_LIST,
  FUNDING_STATUS.RGC_WAITING_LIST,
  FUNDING_STATUS.RGC_TOP_UP_LIST,
  FUNDING_STATUS.RGC_FAILED_LIST,
];

export const FROZEN_STATUS = [
  FUNDING_STATUS.FAILED_LIST,
  FUNDING_STATUS.RGC_FAILED_LIST,
  FUNDING_STATUS.RGC_TOP_UP_LIST,
  FUNDING_STATUS.RGC_WAITING_LIST,
  FUNDING_STATUS.GS_TO_RGC,
  FUNDING_STATUS.SUCCESSFUL_EXCEPTIONALLY_GOOD_LIST,
  FUNDING_STATUS.SUCCESSFUL_GOOD_LIST,
  FUNDING_STATUS.SUCCESSFUL_LIST,
  FUNDING_STATUS.SUCCESSFUL_OUTSTANDING_LIST,
  FUNDING_STATUS.RGC_SUCCESSFUL_LIST,
  FUNDING_STATUS.SUCCESSFUL_VERY_GOOD_LIST,
];
